module.exports = __webpack_public_path__ + "img/boxes.e2cdb10e.png";